import React, { useState, useEffect } from "react";
import "./WeatherForecast.css";
import axios from "axios";
import WeatherForecastDay from "./WeatherForecastDay";

export default function WeatherForecast(props) {
    let [loaded, setLoaded] = useState(false);
    let [forecast, setForecast] = useState(null);

    useEffect(() => {
        setLoaded(false);
    }, [props.coordinates]);
    
    function handleResponse(response){
        setForecast(response.data.daily);
        setLoaded(true);
    }
    function load() {
        let apiKey = "bc7335652f55946eb62094f23f654f47";
        let longitude = props.coordinates.lon;
        let latitude = props.coordinates.lat;
        let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${latitude}&lon=${longitude}&appid=${apiKey}&units=imperial`;

        axios.get(apiUrl).then(handleResponse);
    }
    if (loaded) {
        return (
            <div className="WeatherForecast">
                <div className="row">
                    {forecast.map(function(dailyforecast, index) {
                        if (index < 5) {
                        return (
                        <div className="col" key={index}>
                            <WeatherForecastDay data={dailyforecast} />
                        </div>
                        );
                        } else {
                            return null;
                        }
                    })}
                </div>
            </div>
        );
    } else {
        load();

        return null;
    }
}